import {z} from "zod";

export default z.object({
    layout: z.string(),
    images: z.array(z.object({
        id: z.string().optional(),
        url: z.string(),
        content_hash: z.string().optional(),
        crop: z.any(),
        title: z.string().optional(),
        // media-level credit (refreshed on save) and the per-gallery override
        source: z.string().nullable().optional(),
        source_url: z.string().nullable().optional(),
        credit: z.string().optional(),
        credit_url: z.string().optional(),
    })),
});
